import vwfsLogoFooter from '@/images/clients/vwfs-logo.svg'
import { Market } from 'BrokerTsLib/src/enums'
import type { IPartnerSettings } from '.'

export const VWFS: IPartnerSettings = {
  partner: 'VWFS',
  hosts: [
    'broker-new.cebia.cz'
    , 'broker.cebia.cz'
    // , 'localhost:44470'
  ],
  logo: vwfsLogoFooter,
  market: Market.CZ
}